/* Roomberry Pilzwald-Set — Fragen-Widget (rb-pilzlicht-fragen, Baustein 4, 10.10.2026).
 *
 * Eigenes Asset statt Anhang an rb-pilzlicht.js: das Asset rb-pilzlicht.js liegt byte-gleich in MAIN und
 * trägt die Live-Set-Seite mit. Diese Datei rechnet nichts und enthält keine Zahl: sie schaltet Fragen,
 * Stufen-Ebenen des Bildes und die serverseitig gerenderten Stufen-Fragmente um.
 *
 * Stufe statt Größe (Vorlage rb-pilzregal-fragen, Variante „plus“): z.s ist der 1-basierte Index des
 * Set-Optionswerts (Werte in data-rb-pf-werte, Kurzformen in data-rb-pf-kurz, Lichtzeilen in
 * data-rb-pf-licht — alles aus Liquid, nichts getippt). Die im Widget gewählte Stufe gilt für ALLE Fragen
 * (Runde 17 der Vorlage); der Kaufbox-Stand überschreibt sie nur, wenn sich dort die Stufe wirklich ändert.
 *
 * Kaufbox → Widget: es gibt auf dem Pilzwald kein data-rb-groesse-set (das setzte rb-pilzregal-stil). Gelesen
 * wird der Varianten-Wähler des Themes direkt (Optionsnamen aus der JSON-Insel von rb-pilzlicht-rechnen), auf
 * document 'change', 'click' und den Varianten-ID-Beobachter wie rb-pilzlicht.js.
 * Widget → Kaufbox: „Dieses Set wählen“ trägt data-rb-set-waehlen mit dem vollen Optionswert; den Klick fängt
 * rb-pilzlicht.js (klick → setzeWert) — hier nur Lieferbarkeit prüfen und zum Preisblock scrollen.
 *
 * Farbe: Ebenen mit data-s="farbe" (Farb-Frage) folgen der gewählten Regalfarbe; die übrigen Ebenen hängen
 * an der Stufe (data-s="1"…"4") oder gelten für alle (data-s="alle").
 */
(function () {
  'use strict';
  if (window.RBPilzlichtFragen) { return; }

  function alleIn(wurzel, wahl) { return Array.prototype.slice.call(wurzel.querySelectorAll(wahl)); }
  function lies(text, rueckfall) { try { return JSON.parse(text); } catch (e) { return rueckfall; } }
  function insel() {
    var el = document.querySelector('script[data-rb-pilzlicht-preise]');
    if (!el) { return null; }
    return lies(el.textContent, null);
  }
  function wertVon(optionsname) {
    if (!optionsname) { return ''; }
    var sichere = optionsname.replace(/"/g, '\\"');
    var radio = document.querySelector('input.product-variant-radio[name="' + sichere + '"]:checked');
    if (radio) { return radio.value; }
    var auswahl = document.querySelector('select.product-variant-select[name="' + sichere + '"]');
    if (auswahl) { return auswahl.value; }
    return '';
  }
  function kaufbox() {
    var d = insel();
    if (!d) { return null; }
    return { set: wertVon(d.setOption) || d.setStart || '', farbe: wertVon(d.farbOption) || d.farbStart || '' };
  }

  function init(w) {
    if (!w || w.getAttribute('data-rb-pf-bereit') === 'ja') { return; }
    w.setAttribute('data-rb-pf-bereit', 'ja');
    function alle(s) { return alleIn(w, s); }

    var werte = lies(w.getAttribute('data-rb-pf-werte') || '[]', []);
    var kurz = lies(w.getAttribute('data-rb-pf-kurz') || '[]', []);
    var licht = lies(w.getAttribute('data-rb-pf-licht') || '[]', []);
    var nS = werte.length;
    var tabs = alle('[data-rb-pf-tab]');
    var panels = alle('[data-rb-pf-panel]');
    var ebenen = alle('[data-rb-pf-ebene]');
    var n = tabs.length;
    var marke = w.querySelector('[data-rb-pf-marke]');
    var band = w.querySelector('[data-rb-pf-band]');
    var bandText = w.querySelector('[data-rb-pf-band-text]');
    var bandQuelle = w.querySelector('[data-rb-pf-band-quelle]');
    var karte = w.querySelector('[data-rb-pf-karte]');
    var stapel = w.querySelector('.rb-pf__stapel');
    var ruhig = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var schmal = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
    var textWaehlen = w.getAttribute('data-rb-pf-text-waehlen') || '';
    var textGewaehlt = w.getAttribute('data-rb-pf-text-gewaehlt') || '';
    var textWeg = w.getAttribute('data-rb-pf-text-weg') || '';

    var k0 = kaufbox();
    var startS = Number(w.getAttribute('data-rb-pf-start')) || 1;
    if (k0 && k0.set) {
      var i0 = werte.indexOf(k0.set);
      if (i0 >= 0) { startS = i0 + 1; }
    }
    var z = { f: 1, s: startS, farbe: k0 ? k0.farbe : (w.getAttribute('data-rb-pf-farbe-start') || '') };
    var zuletztSet = k0 ? k0.set : (werte[startS - 1] || '');
    var zuletztFarbe = z.farbe;
    var uhrHoehe = null, uhrKarte = null;

    function lade(e) { if (e && e.hasAttribute('data-rb-pf-spaeter')) { e.removeAttribute('data-rb-pf-spaeter'); } }

    function ebene(f, s, farbe) {
      var farbTreffer = null, passend = null, gemein = null, irgend = null;
      ebenen.forEach(function (e) {
        if (Number(e.getAttribute('data-f')) !== f) { return; }
        var es = e.getAttribute('data-s');
        if (es === 'farbe') {
          if (e.getAttribute('data-farbe') === farbe) { farbTreffer = e; }
        } else if (es === String(s)) {
          passend = e;
        } else if (es === 'alle') {
          gemein = e;
        }
        if (!irgend) { irgend = e; }
      });
      return farbTreffer || passend || gemein || irgend;
    }

    /* Lieferbar laut JSON-Insel (Feld "da"); ohne Insel oder ohne Treffer entscheidet das Theme. */
    function lieferbar(s) {
      var d = insel(), k = kaufbox();
      if (!d || !d.varianten || !k) { return true; }
      for (var i = 0; i < d.varianten.length; i += 1) {
        var v = d.varianten[i];
        if (v.set === werte[s - 1] && v.farbe === k.farbe) { return v.da !== false; }
      }
      return true;
    }

    function videosAnhalten(ausser) {
      alle('video').forEach(function (v) {
        if (ausser && ausser.contains(v)) { return; }
        if (!v.paused) { v.pause(); }
      });
    }

    function panelWechsel(neu) {
      videosAnhalten(neu);
      var ohneAnimation = ruhig.matches || !karte || !karte.getBoundingClientRect;
      var von = ohneAnimation ? 0 : karte.getBoundingClientRect().height;
      panels.forEach(function (p) { p.hidden = p !== neu; p.classList.toggle('ist-an', p === neu); });
      if (ohneAnimation || !von) { if (karte) { karte.style.height = ''; } return; }
      karte.style.height = 'auto';
      var nach = karte.getBoundingClientRect().height;
      karte.style.height = von + 'px';
      void karte.offsetHeight;
      karte.style.height = nach + 'px';
      clearTimeout(uhrHoehe);
      uhrHoehe = setTimeout(function () { karte.style.height = ''; }, 320);
    }

    function knopfZeichnen() {
      var k = kaufbox();
      var wert = werte[z.s - 1] || '';
      alle('[data-rb-pf-waehlen]').forEach(function (b) {
        if (wert) { b.setAttribute('data-rb-set-waehlen', wert); }
        var gewaehlt = !!(k && k.set && k.set === wert);
        b.textContent = gewaehlt ? textGewaehlt : textWaehlen;
        if (gewaehlt) { b.setAttribute('aria-disabled', 'true'); } else { b.removeAttribute('aria-disabled'); }
      });
    }

    function zeichne() {
      var f = z.f, s = z.s;
      tabs.forEach(function (t) {
        var an = Number(t.getAttribute('data-rb-pf-tab')) === f;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.tabIndex = an ? 0 : -1;
      });
      var panel = null;
      panels.forEach(function (p) { if (Number(p.getAttribute('data-rb-pf-panel')) === f) { panel = p; } });
      var ziel = ebene(f, s, z.farbe);
      lade(ziel);
      ebenen.forEach(function (e) {
        var an = e === ziel;
        e.classList.toggle('ist-an', an);
        e.setAttribute('aria-hidden', an ? 'false' : 'true');
      });
      if (marke) { marke.textContent = f + '/' + n; }
      var tab = tabs[f - 1];
      if (band && tab) {
        var zt = tab.getAttribute('data-rb-pf-zitat') || '';
        if (bandText) { bandText.textContent = zt; }
        if (bandQuelle) { bandQuelle.textContent = tab.getAttribute('data-rb-pf-quelle') || ''; }
        band.hidden = !zt;
      }
      alle('[data-rb-pf-sname]').forEach(function (el) { el.textContent = kurz[s - 1] || ''; });
      alle('[data-rb-pf-slicht]').forEach(function (el) { el.textContent = licht[s - 1] || ''; });
      alle('[data-rb-pf-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-rb-pf-chip') === String(s) ? 'true' : 'false'); });
      alle('[data-rb-pf-sz]').forEach(function (el) { el.classList.toggle('ist-an', el.getAttribute('data-rb-pf-sz') === String(s)); });
      var sparLeer = true;
      alle('[data-rb-pf-spar]').forEach(function (el) {
        var an = el.getAttribute('data-rb-pf-spar') === String(s);
        el.classList.toggle('ist-an', an);
        if (an && el.textContent.replace(/\s+/g, '') !== '') { sparLeer = false; }
      });
      alle('[data-rb-pf-bezug]').forEach(function (el) { el.hidden = sparLeer; });
      knopfZeichnen();
      return panel;
    }

    function bildZeigen() {
      if (!stapel || !stapel.scrollIntoView) { return; }
      var r = stapel.getBoundingClientRect();
      if (r.bottom < 64 || r.bottom > window.innerHeight) {
        stapel.scrollIntoView({ block: 'start', behavior: ruhig.matches ? 'auto' : 'smooth' });
      }
    }

    function karteZeigen() {
      if (!karte || !karte.scrollIntoView) { return; }
      clearTimeout(uhrKarte);
      uhrKarte = setTimeout(function () {
        var r = karte.getBoundingClientRect();
        if (r.top > window.innerHeight - 200) { karte.scrollIntoView({ block: 'nearest', behavior: ruhig.matches ? 'auto' : 'smooth' }); }
      }, ruhig.matches ? 0 : 320);
    }

    function waehle(f, fokus) {
      z.f = f;
      panelWechsel(zeichne());
      var t = tabs[f - 1];
      if (fokus && t) { t.focus({ preventScroll: true }); }
    }

    function setzeStufe(s) {
      s = Number(s);
      if (!s || s < 1 || s > nS) { return; }
      z.s = s;
      alle('[data-rb-pf-hinweis]').forEach(function (h) { h.textContent = ''; });
      zeichne();
    }

    tabs.forEach(function (t) {
      var tf = Number(t.getAttribute('data-rb-pf-tab'));
      t.addEventListener('pointerdown', function () { lade(ebene(tf, z.s, z.farbe)); });
      t.addEventListener('focus', function () { lade(ebene(tf, z.s, z.farbe)); });
      t.addEventListener('click', function () { waehle(tf, false); if (schmal.matches) { bildZeigen(); } else { karteZeigen(); } });
      t.addEventListener('keydown', function (e) {
        var f = z.f, neu = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { neu = f === n ? 1 : f + 1; }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { neu = f === 1 ? n : f - 1; }
        if (e.key === 'Home') { neu = 1; }
        if (e.key === 'End') { neu = n; }
        if (neu) { e.preventDefault(); waehle(neu, true); }
      });
    });
    var reihe = w.querySelector('[data-rb-pf-reihe]');
    if (reihe) { reihe.setAttribute('aria-orientation', 'vertical'); }

    alle('[data-rb-pf-chip]').forEach(function (c) {
      var vorladen = function () { lade(ebene(z.f, Number(c.getAttribute('data-rb-pf-chip')), z.farbe)); };
      c.addEventListener('pointerdown', vorladen);
      c.addEventListener('focus', vorladen);
      c.addEventListener('click', function () { setzeStufe(c.getAttribute('data-rb-pf-chip')); if (schmal.matches) { bildZeigen(); } });
    });

    /* „Preis-Details ansehen“ in der Ersparnis-Frage stellt die Kaufbox vorher auf die Widget-Stufe, damit
       Preisblock und Karte dieselbe Stufe zeigen (Vorlage Runde 17). Dieselbe Tür data-rb-set-waehlen. */
    alle('[data-rb-springen]').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = b.closest('[data-rb-pf-panel]');
        if (!panel || panel.getAttribute('data-rb-pf-modus') !== 'ersparnis') { return; }
        var k = kaufbox(), wert = werte[z.s - 1] || '';
        if (!wert || !lieferbar(z.s) || (k && k.set === wert)) { return; }
        var t = document.createElement('button');
        t.type = 'button'; t.hidden = true; t.setAttribute('data-rb-set-waehlen', wert);
        w.appendChild(t); t.click(); w.removeChild(t);
        window.setTimeout(knopfZeichnen, 400);
      }, true);
    });

    alle('[data-rb-pf-waehlen]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        if (b.getAttribute('aria-disabled') === 'true') { ev.stopPropagation(); ev.preventDefault(); return; }
        var hinweis = b.parentNode ? b.parentNode.nextElementSibling : null;
        if (!hinweis || !hinweis.hasAttribute('data-rb-pf-hinweis')) { hinweis = w.querySelector('[data-rb-pf-hinweis]'); }
        if (!lieferbar(z.s)) {
          ev.stopPropagation();
          ev.preventDefault();
          if (hinweis) { hinweis.textContent = textWeg; }
          return;
        }
        if (hinweis) { hinweis.textContent = ''; }
        var ziel = document.querySelector('.product-information-price:not(.product-move-above-media)') ||
          document.querySelector('.rb-pr-vorteil') || document.querySelector('.rb-pl-spar') || document.querySelector('.product-information-buy-buttons');
        window.setTimeout(function () {
          if (ziel && ziel.getBoundingClientRect) {
            var oben = ziel.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 16;
            window.scrollTo({ top: Math.max(0, oben), behavior: ruhig.matches ? 'auto' : 'smooth' });
          }
          knopfZeichnen();
        }, 80);
        window.setTimeout(knopfZeichnen, 400);
      });
    });

    /* „Noch eine Stimme“: ein Platz, zwei Zitate im Wechsel */
    alle('[data-rb-pf-stimme]').forEach(function (s) {
      var knopf = s.querySelector('[data-rb-pf-noch]');
      if (!knopf) { return; }
      var zweite = false;
      knopf.addEventListener('click', function () {
        zweite = !zweite;
        var t = s.querySelector('[data-rb-pf-stimme-text]'), q = s.querySelector('[data-rb-pf-stimme-quelle]');
        if (t) { t.textContent = s.getAttribute(zweite ? 'data-rb-pf-s2' : 'data-rb-pf-s1') || ''; }
        if (q) { q.textContent = s.getAttribute(zweite ? 'data-rb-pf-s2q' : 'data-rb-pf-s1q') || ''; }
      });
    });

    /* Video: nichts spielt von selbst. Öffnen setzt das Poster und startet stumm; Zuklappen pausiert. */
    alle('[data-rb-pf-video]').forEach(function (box) {
      var film = box.querySelector('video');
      if (!film) { return; }
      film.muted = true; film.defaultMuted = true; film.playsInline = true;
      box.addEventListener('toggle', function () {
        if (box.open) {
          var poster = film.getAttribute('data-poster');
          if (poster && !film.getAttribute('poster')) { film.setAttribute('poster', poster); }
          var lauf = film.play && film.play();
          if (lauf && lauf.catch) { lauf.catch(function () { }); }
        } else if (!film.paused) { film.pause(); }
      });
    });

    /* Kaufbox → Widget: nur nachführen, wenn sich dort Stufe oder Farbe wirklich ändert — nie einen Chip-Tipp überschreiben. */
    function nachlesen() {
      var k = kaufbox();
      if (!k) { return; }
      var geaendert = false;
      if (k.set && k.set !== zuletztSet) {
        zuletztSet = k.set;
        var i = werte.indexOf(k.set);
        if (i >= 0 && i + 1 !== z.s) { z.s = i + 1; geaendert = true; }
      }
      if (k.farbe && k.farbe !== zuletztFarbe) {
        zuletztFarbe = k.farbe;
        z.farbe = k.farbe;
        geaendert = true;
      }
      if (geaendert) { zeichne(); } else { knopfZeichnen(); }
    }
    document.addEventListener('change', function () { window.setTimeout(nachlesen, 180); });
    document.addEventListener('click', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('[data-rb-pf]') === w) { return; }
      window.setTimeout(nachlesen, 180);
    });
    var feld = document.querySelector('form[action^="/cart/add"] input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (feld && window.MutationObserver) {
      new MutationObserver(function () { window.setTimeout(nachlesen, 60); }).observe(feld, { attributes: true, attributeFilter: ['value'] });
    }
    window.setTimeout(nachlesen, 1200);

    /* In Sichtnähe nur das Bild der aktiven Frage in der gewählten Stufe laden; andere Ebenen erst bei pointerdown/focus. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (!e[0] || !e[0].isIntersecting) { return; }
        io.disconnect();
        lade(ebene(z.f, z.s, z.farbe));
      }, { rootMargin: '300px 0px' });
      io.observe(w);
    }

    zeichne();
  }

  function alleStarten() { Array.prototype.slice.call(document.querySelectorAll('[data-rb-pf]')).forEach(init); }
  window.RBPilzlichtFragen = { start: alleStarten };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', alleStarten); } else { alleStarten(); }
  document.addEventListener('shopify:section:load', alleStarten);
}());
